import React from 'react'
import {
    Autocomplete,
    CalculatorIcon,
    FilterRemoveIcon,
    IconButton,
    Label,
    Pane, SearchInput,
    SelectField,
    TextInputField,
    toaster,
    Tooltip
} from "evergreen-ui";
import {useDispatch, useSelector} from "react-redux";
import {selectorStationsForFilters} from "../../Constructor/periodValuesFilterApi";
import {findFirstByCode, findFirstByName} from "../../Constructor/common/matchMethods";
import {
    getCodesByStation,
    getEntitiesByStationAndDatasourceTypeId,
    getTypesByStationAndMeteoCode
} from "../../Constructor/decadeConstructor/ApiCalls";
import {
    clearState,
    selectCheckedDatasourceTypeForSensorDeviation,
    selectCheckedStationEntityForSensorDeviation,
    selectCodeForSensorDeviation,
    selectIdealDatasourceTypeForSensorDeviation,
    selectIdealStationEntityForSensorDeviation,
    selectStationForSensorDeviation
} from "./SensorDeviationSlice";
import SmartButton from "../../Constructor/common/SmartButton";
import {generateDeviationReport} from "./Api";

export default function SensorDeviationPage() {
    const dispatch = useDispatch();

    const deviationData = useSelector((state) => state.sensorDeviation)
    const stations = useSelector(selectorStationsForFilters);
    const [availableDatasourcesTypes, setAvailableDatasourcesTypes] = React.useState([])
    const [availableCheckedStationEntities, setAvailableCheckedStationEntities] = React.useState([])
    const [availableIdealStationEntities, setAvailableIdealStationEntities] = React.useState([])
    const [availableCodesForCheckedDatasource, setAvailableCodesForCheckedDatasource] = React.useState([])
    const [availableCodesForIdealDatasource, setAvailableCodesForIdealDatasource] = React.useState([])

    const [availableCodes, setAvailableCodes] = React.useState([])


    const [periodStart, setPeriodStart] = React.useState(0)
    const [periodEnd, setPeriodEnd] = React.useState(0)


    function onCalculate() {
        const d1 = new Date(periodStart)
        const d2 = new Date(periodEnd)
        if (d2 < d1) {
            toaster.danger("Дата начала не может быть позже, чем дата окончания!")
        } else {
            generateDeviationReport(deviationData, periodStart, periodEnd)
        }
    }

    function onSelectStation(stationName) {
        stationName = stationName.split("] ")[1]
        let res = findFirstByName(stations, stationName)

        getCodesByStation(res.id).then(result => {
            setAvailableCodes(result.data)
            dispatch(selectStationForSensorDeviation(res));
        })
    }

    function onSelectCheckedDatasourceType(name) {
        let res = findFirstByName(availableDatasourcesTypes, name)

        getEntitiesByStationAndDatasourceTypeId(deviationData.station.id, res.id).then((result) => {
            res = {id: res.id, name: res.name, entities: result.data}
            setAvailableCheckedStationEntities(result.data)
            dispatch(selectCheckedDatasourceTypeForSensorDeviation(res))
        })
    }

    function onSelectIdealDatasourceType(name) {
        let res = findFirstByName(availableDatasourcesTypes, name)

        getEntitiesByStationAndDatasourceTypeId(deviationData.station.id, res.id).then((result) => {
            res = {id: res.id, name: res.name, entities: result.data}
            setAvailableIdealStationEntities(result.data)
            dispatch(selectIdealDatasourceTypeForSensorDeviation(res))
        })
    }

    function onSelectCheckedStationEntity(name) {
        let res = findFirstByName(availableCheckedStationEntities, name)
        dispatch(selectCheckedStationEntityForSensorDeviation(res))

    }

    function onSelectIdealStationEntity(name) {
        let res = findFirstByName(availableIdealStationEntities, name)
        dispatch(selectIdealStationEntityForSensorDeviation(res))
    }


    function onSelectCode(code) {
        const res = findFirstByCode(availableCodes, code)
        getTypesByStationAndMeteoCode(deviationData.station.id, res.id).then((result) => {
            setAvailableDatasourcesTypes(result.data)
            dispatch(selectCodeForSensorDeviation(res));
        })

    }

    function isButtonDisabled() {
        return !deviationData.station.name
            || !deviationData.checkedDatasourceType.name || !deviationData.idealDatasourceType.name ||
            !deviationData.code.code || periodStart == 0 || periodEnd == 0
    }

    function clearFilter() {
        dispatch(clearState())
        setPeriodStart(0)
        setPeriodEnd(0)
    }

    function createFullStationName(station) {
        if (station.name === undefined && station.idx === undefined) return ""

        const name = station.name === undefined ? "" : station.name
        const idx = station.idx === undefined ? "" : station.idx
        return "[" + idx + "] " + name;
    }

    return (
        <Pane margin={40} display={"block"}>
            <Pane columnGap={10} marginBottom={20}>
                <Pane marginBottom={10}>
                    Проверяемая станция
                </Pane>
                <Autocomplete
                    onSelect={selectedItem => onSelectStation(selectedItem)}
                    initialInputValue={createFullStationName(deviationData.station)}
                    items={stations.map(createFullStationName).sort()}
                    selectedItem={createFullStationName(deviationData.station)}
                >
                    {({
                          key,
                          getInputProps,
                          getRef,
                          inputValue,
                          openMenu,
                      }) => (
                        <Pane key={key} ref={getRef} display="flex" width={220}>
                            <SearchInput
                                width={250}
                                placeholder="Название станции"
                                value={createFullStationName(deviationData.station)}
                                ref={getRef}
                                onFocus={openMenu}
                                {...getInputProps()}
                            />
                        </Pane>
                    )}
                </Autocomplete>
            </Pane>
            <Pane marginBottom={4} alignItems={"top"}>
                <Pane display="flex" columnGap={25}>
                    <Pane verticalAlign={"top"}>
                        <SelectField
                            label={"Данные для проверки"}
                            width={250}
                            onClick={() => {
                                if (availableCodes.length === 0 && deviationData.station.name) {
                                    toaster.danger("Нет ни одного доступного кода для проверки. Измените проверяемую станцию")
                                }
                            }}
                            onChange={x => onSelectCode(x.target.value)}
                            value={deviationData.code.code}
                            disabled={!deviationData.station.name}
                        >
                            <option value={-1}>Выберите метеокод</option>
                            {availableCodes.map((code) => <option key={code.id} value={code.code}>{code.code}</option>)}
                        </SelectField>
                    </Pane>
                    <Pane verticalAlign={"top"}>
                        <SelectField
                            label={"Проверяемый источник"}
                            width={250}
                            onChange={x => onSelectCheckedDatasourceType(x.target.value)}
                            onClick={() => {
                                if (availableDatasourcesTypes.length === 0 && deviationData.code.code) {
                                    toaster.danger("Нет ни одного источника для проверяемых данных на этой станции.")
                                }
                            }}
                            value={deviationData.checkedDatasourceType.name}
                            disabled={!deviationData.code.code}
                        >
                            <option value={-1}>Выберите источник</option>
                            {availableDatasourcesTypes.map((ds) => <option key={ds.name} value={ds.name}>{ds.name}</option>)}
                        </SelectField>
                    </Pane>
                    
                    <Pane verticalAlign={"top"}>
                        <SelectField
                            label={"Проверяемый пункт наблюдения"}
                            width={250}
                            onChange={x => onSelectCheckedStationEntity(x.target.value)}
                            value={deviationData.checkedStationEntity.name}
                            disabled={!deviationData.checkedDatasourceType.name}
                        >
                            <option value={-1}>Выберите пункт наблюдения</option>
                            {availableCheckedStationEntities
                                .filter((el) => el.name !== 'Датчик')
                                .map((ds) => <option key={ds.name} value={ds.name}>{ds.name}</option>)}
                        </SelectField>
                    </Pane>

                    <Pane verticalAlign={"top"}>
                        <SelectField
                            label={"Эталонный источник"}
                            width={250}
                            onChange={x => onSelectIdealDatasourceType(x.target.value)}
                            onClick={() => {
                                if (availableDatasourcesTypes.length === 0 && deviationData.code.code) {
                                    toaster.danger("Нет ни одного источника для проверяемых данных на этой станции.")
                                }
                            }}
                            value={deviationData.idealDatasourceType.name}
                            disabled={!deviationData.code.code}
                        >
                            <option value={-1}>Выберите источник</option>
                            {availableDatasourcesTypes.map((ds) => <option key={ds.name} value={ds.name}>{ds.name}</option>)}
                        </SelectField>
                    </Pane>

                    <Pane verticalAlign={"top"}>
                        <SelectField
                            label={"Эталонный пункт наблюдения"}
                            width={250}
                            onChange={x => onSelectIdealStationEntity(x.target.value)}
                            value={deviationData.idealStationEntity.name}
                            disabled={!deviationData.idealDatasourceType.name}
                        >
                            <option value={-1}>Выберите пункт наблюдения</option>
                            {availableIdealStationEntities
                                .filter((el) => el.name !== 'Датчик')
                                .map((ds) => <option key={ds.name} value={ds.name}>{ds.name}</option>)}
                        </SelectField>
                    </Pane>
                </Pane>
            </Pane>
            <Pane>
                <Label>Временной интервал для расчета отклонений</Label>
                <Pane display={"flex"} columnGap={"25"} marginTop={10}>
                    <TextInputField
                        label="Дата начала"
                        width={300}
                        type="datetime-local"
                        name="startDate"
                        max={periodEnd}
                        value={periodStart}
                        onChange={val => {
                            setPeriodStart(val.target.value)
                        }}
                    />
                    <TextInputField
                        label="Дата окончания"
                        width={300}
                        type="datetime-local"
                        name="endDate"
                        value={periodEnd}
                        min={periodStart}
                        onChange={val => {
                            setPeriodEnd(val.target.value)
                        }}
                    />
                </Pane>

                <Pane display={"flex"} gap={10}>
                    <SmartButton
                        iconAfter={CalculatorIcon}
                        isPrimary={true}
                        onClickAction={() => onCalculate()}
                        isDisabled={isButtonDisabled()}
                        disabledTooltip={"Выберите все фильтры"}
                        buttonText={"Рассчитать"}
                    />
                    <Tooltip content="Сбросить">
                        <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                    </Tooltip>
                </Pane>
            </Pane>
        </Pane>
    )
}